angular.module('zc.master.zcliteReports', [
  'zc.master'
])



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_reports/index.coffee